/**
 * RESPONSIBILITY: draw a block of questions with answers that open.
 *
 * <details>, not a scripted accordion: it opens without JavaScript and the browser's own
 * find-in-page reaches a closed answer.
 */
import { Html } from '@framework/react';
import { idOf } from '@framework/core';
import { ADC_THEME } from '@app/sections';
import { AdcBand } from './AdcBand';
import type { AdcBlockProps } from './kind';

export function AdcFaq({ b }: AdcBlockProps) {
  const qs = (b.questions ?? []).filter((q) => q.question);
  if (!qs.length) return null;

  return (
    <AdcBand theme={ADC_THEME.Faq} heading={b.heading}>
      <div className="ev-faq adc-faq">
        {qs.map((q) => (
          <details key={idOf(q)}>
            <summary>{q.question}</summary>
            {q.answerHtml ? <Html className="md-body">{q.answerHtml}</Html> : null}
          </details>
        ))}
      </div>
    </AdcBand>
  );
}
